import { DonationStep } from '@/interfaces/donationStep';
import { stepV1, stepV2 } from '@/enums/donationStepOrder';
import { DonationStepFlowVersion } from '@/enums/donationStepFlowVersion';

const v1DonationSteps = [
  {
    step: stepV1.LOADING,
    title: 'Loader',
    componentReference: 'Loader',
  },
  {
    step: stepV1.DONATION_TYPE,
    title: 'DonationType',
    componentReference: 'DonationType',
  },
  {
    step: stepV1.INFORMATION,
    title: 'Information',
    componentReference: 'Information',
  },
  {
    step: stepV1.CASE,
    title: 'DonationCase',
    componentReference: 'DonationCase',
  },
  {
    step: stepV1.DONOR,
    title: 'DonorDetails',
    componentReference: 'DonorDetails',
  },
  {
    step: stepV1.DONATION_DETAILS,
    title: 'DonationDetails',
    componentReference: 'DonationDetails',
  },
  {
    step: stepV1.PAYMENT_AND_DELIVERY,
    title: 'PaymentDelivery',
    componentReference: 'PaymentDelivery',
  },
  {
    step: stepV1.SUMMARY,
    title: 'Summary',
    componentReference: 'Summary',
  },
  {
    step: stepV1.PAYMENT,
    title: 'Payment',
    componentReference: 'Payment',
  },
  {
    step: stepV1.SUCCESS,
    title: 'Success',
    componentReference: 'Success',
  },
  {
    step: stepV1.PAYMENT_LINK,
    title: 'Paylink',
    componentReference: 'Paylink',
  },
] as Array<DonationStep>;

const v2DonationSteps = [
  {
    step: stepV2.LOADING,
    title: 'Loader',
    componentReference: 'Loader',
  },
  {
    step: stepV2.DONATION_TYPE,
    title: 'DonationType',
    componentReference: 'DonationType',
  },
  {
    step: stepV2.INFORMATION,
    title: 'Information',
    componentReference: 'Information',
  },
  {
    step: stepV2.CERTIFICATE_DETAILS,
    title: "CertificateDetails",
    componentReference: "CertificateDetails",
  },
  {
    step: stepV2.CASE,
    title: 'DonationCase',
    componentReference: 'DonationCase',
  },
  {
    step: stepV2.PAYMENT_AND_DELIVERY,
    title: 'PaymentDelivery',
    componentReference: 'PaymentDelivery',
  },
  {
    step: stepV2.SUMMARY,
    title: 'Summary',
    componentReference: 'Summary',
  },
  {
    step: stepV2.PAYMENT,
    title: 'Payment',
    componentReference: 'Payment',
  },
  {
    step: stepV2.SUCCESS,
    title: 'Success',
    componentReference: 'Success',
  },
  {
    step: stepV2.PAYMENT_LINK,
    title: 'Paylink',
    componentReference: 'Paylink',
  },
] as Array<DonationStep>;

export function getDonationSteps(version: DonationStepFlowVersion): Array<DonationStep> {
  if (version === DonationStepFlowVersion.V2) {
    return v2DonationSteps;
  }
  return v1DonationSteps;
}

export function getDonationStep(donationStep: number, version: DonationStepFlowVersion): DonationStep {
  let donationSteps: Array<DonationStep> = version === DonationStepFlowVersion.V2 ? v2DonationSteps : v1DonationSteps;
  const step: DonationStep | null = donationSteps.find((step) => step.step === donationStep) || null;
  if (step) {
    return step;
  } else {
    // should ever never happen.
    console.error(`Guide step ${donationStep} not found`);
    return donationSteps[0];
  }
}
